var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u269B atoms/icons/16/confirm/hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u269B-atoms/icons/16/confirm/hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "confirm-empty",
    transform: "translate(0.200000, 0.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8,0.458823529 C11.8544198,0.458823529 15.1411765,3.74558019 15.1411765,7.8 C15.1411765,11.8544198 11.8544198,15.1411765 7.8,15.1411765 C3.74558019,15.1411765 0.458823529,11.8544198 0.458823529,7.8 C0.458823529,3.74558019 3.74558019,0.458823529 7.8,0.458823529 Z M7.8,1.37647059 C4.25238267,1.37647059 1.37647059,4.25238267 1.37647059,7.8 C1.37647059,11.3476173 4.25238267,14.2235294 7.8,14.2235294 C11.3476173,14.2235294 14.2235294,11.3476173 14.2235294,7.8 C14.2235294,4.25238267 11.3476173,1.37647059 7.8,1.37647059 Z",
    id: "Mask",
    fill: "#00CE82",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.4,
    stroke: "#00CE82",
    strokeWidth: 4,
    cx: 7.8,
    cy: 7.8,
    r: 5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonHover);
export default __webpack_public_path__ + "static/media/button-hover.aae3a21761850bbb7a719eeed852acf8.svg";
export { ForwardRef as ReactComponent };